import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Select, Spin, message } from 'antd';
import axios from '../../../config/axiosInstance';

const { Option } = Select;

const ModuleClientRegasus = ({ form }) => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);

    const selectedValue = Form.useWatch('regasusDownloadUrl', form);

    useEffect(() => {
        const fetchClients = async () => {
            setLoading(true);
            try {
                const response = await axios.get('/apps/regasus/clients');

                if (Array.isArray(response.data)) {
                    setClients(response.data);
                } else {
                    message.error('Unexpected response format while loading Regasus clients.');
                }
            } catch (error) {
                console.error('Error fetching Regasus clients:', error);
                message.error('Failed to load Regasus clients');
            } finally {
                setLoading(false);
            }
        };

        fetchClients();
    }, []);

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
                <Form.Item name="regasusDownloadUrl"  label="Regasus Client">
                    {loading ? (
                        <Spin />
                    ) : (
                        <Select
                            placeholder="Select a client"
                            value={selectedValue}
                            onChange={(value) => form.setFieldsValue({ regasusDownloadUrl: value })}
                            allowClear
                            onClear={() => form.setFieldsValue({ regasusDownloadUrl: null })}
                        >
                            {clients.map((client) => (
                                <Option key={client} value={`misc/${client}/`}>
                                    {client}
                                </Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
            </Col>
        </Row>
    );
};

export default ModuleClientRegasus;